module.exports = __webpack_public_path__ + "img/userinfo_bg.4acf20d.png";